"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function convertJsPdfToFormData(pdfFile, filename) {
    const blob = pdfFile.output("blob");
    const formData = new FormData();
    formData.append("pdf", blob);
    formData.append("file_name", filename);
    return formData;
}
exports.default = convertJsPdfToFormData;
